import React from 'react';
import styled from 'styled-components';
import Title from '../title';

const SkiTransfersSection = styled.section`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 1024px;
    width: 100%;
    margin-top: -100px;
`;

const SkiTransfersSectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    position: relative;
    background-position: top;
    padding-top: 150px;
`;

// Create a peak label marker component
const PeakLabel = styled.div`
    position: absolute;
    top: ${({ top }) => top || '50%'};
    left: ${({ left }) => left || '50%'};
    transform: translate(-50%, -50%);
    color: white;
    font-family: 'Montserrat';
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.9rem;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    &:after {
        content: '';
        position: absolute;
        bottom: -140px;
        left: 0;
        width: 4px;
        height: 150px;
        background-color: black;
        border-radius: 5px;
    }
`;

const PeakLabelTitle = styled.span`
    font-size: 1rem;
    font-weight: 700;
    background-color: black;
    padding: 0 7px;
`;

const PeakAltitude = styled.span`
    font-size: 0.8rem;
    font-weight: 400;
    background-color: black;
    padding: 0 7px;
`;

const _SkiTransfersSection = () => {
    return (
        <SkiTransfersSection>
            <SkiTransfersSectionContainer className='bg-ski-transfers'>
                <h1 className="text-4xl font-['Montserrat'] uppercase text-[#000000] [text-shadow:_1px_1px_5px_rgb(0_0_0_/_60%)]">
                    Transferts Ski
                </h1>
                <PeakLabel top='32%' left='15%'>
                    <PeakLabelTitle>
                        Mont-Blanc
                    </PeakLabelTitle>
                    <PeakAltitude>
                        4808m
                    </PeakAltitude>
                </PeakLabel>
                <PeakLabel top='57%' left='31%'>
                    <PeakLabelTitle>
                        Matterhorn
                    </PeakLabelTitle>
                    <PeakAltitude>
                        4478m
                    </PeakAltitude>
                </PeakLabel>
                <PeakLabel top='43%' left='50%'>
                    <PeakLabelTitle>
                        Dufourspitze
                    </PeakLabelTitle>
                    <PeakAltitude>
                        4634m
                    </PeakAltitude>
                </PeakLabel>
                <PeakLabel top='35%' left='68%'>
                    <PeakLabelTitle>
                        Eiger
                    </PeakLabelTitle>
                    <PeakAltitude>
                        3967m
                    </PeakAltitude>
                </PeakLabel>
                <PeakLabel top='49%' left='86%'>
                    <PeakLabelTitle>
                        Grossglockner
                    </PeakLabelTitle>
                    <PeakAltitude>
                        3798m
                    </PeakAltitude>
                </PeakLabel>
            </SkiTransfersSectionContainer>
        </SkiTransfersSection>
    );
}

export default _SkiTransfersSection;